import React from 'react';
import GalleryTemplate from '../../Templates/GalleryTemplate';

const galleryPage = props => <GalleryTemplate />

export default galleryPage;